export function cardsScripts(): void {
    const cardLists = document.querySelectorAll('bg-card-list:has(.bg-card-cropped-image)');
    if (cardLists.length === 0) {
        return;
    }

    function updateVisibleItems() {
        if (cardLists.length === 0) {
            return;
        }
        
        const clientWidth = document.documentElement.clientWidth;
        let maxVisible = 7;
        if (clientWidth <= 768) {
            maxVisible = 3;
        } else if (clientWidth <= 1240) {
            maxVisible = 5;
        }

        cardLists.forEach(cardList => {
            const items = cardList.querySelectorAll<HTMLElement>('.bg-card-cropped-image');
            items.forEach((image, index) => {
                image.style.display = index < maxVisible ? 'block' : 'none';
            });
        });
    }

    updateVisibleItems();
    window.addEventListener('DOMContentLoaded', updateVisibleItems);
    window.addEventListener('resize', updateVisibleItems);
    window.addEventListener('orientationchange', updateVisibleItems);
}